var _defs, _path, _rect, _path2, _path3, _path4, _path5, _rect2, _path6, _path7, _path8, _path9, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxedAlumniPortalLogoV3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 249.173,
    height: 43.2,
    viewBox: "0 0 249.173 43.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2774ae;}.b{fill:#fff;}.c{font-size:24px;font-family:Helvetica-Bold, Helvetica;font-weight:700;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.3,12.9h3.6L116,30.2h-3.7l-1.2-3.7h-6.3l-1.1,3.7h-3.6Zm-.5,11h4.6l-1.6-5c-.3-.9-.7-2.7-.7-2.7h0s-.4,1.7-.7,2.7Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 17.3,
    transform: "translate(117.1 12.9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.4,30.3V28.8h-.1a4.023,4.023,0,0,1-3.6,1.8c-2.8,0-4.3-1.8-4.3-4.5V17.8h3.3v7.7c0,1.5.7,2.3,2.1,2.3a2.5,2.5,0,0,0,2.5-2.8V17.8h3.3V30.2h-3.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.7,17.8h3.2v1.7h.1a4.165,4.165,0,0,1,3.6-2,3.649,3.649,0,0,1,3.4,2.2h0a4.248,4.248,0,0,1,3.7-2.2c2.6,0,4.1,1.7,4.1,4.4v8.4h-3.3V22.5c0-1.4-.7-2.1-1.9-2.1-1.4,0-2.2,1.1-2.2,2.7v7.2h-3.3V22.5c0-1.4-.7-2.1-1.9-2.1-1.3,0-2.2,1.1-2.2,2.7v7.2h-3.3V17.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.1,19.5h0a4.32,4.32,0,0,1,3.8-2c2.6,0,4.3,1.9,4.3,4.7v8.1h-3.3V22.7a2.126,2.126,0,0,0-2.2-2.3c-1.5,0-2.5,1.2-2.5,2.9v7.1h-3.3V17.8h3.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.2,12.9h3.3v3h-3.3Zm0,4.9h3.3V30.2h-3.3Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 92.1,
    height: 43.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.7,25.7a16.077,16.077,0,0,1,0-2.2l1-11.8h3.9L18.5,23.6c-.2,2.6.8,4.4,3.3,4.4A4.141,4.141,0,0,0,26,23.9l1.1-12.1H31l-1.1,12c-.4,4.6-3.5,8.1-8.4,8.1a6.77,6.77,0,0,1-6.8-6.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.9,21.8c.5-5.6,4.3-10.3,10.9-10.3A9.108,9.108,0,0,1,47.9,13l-.4,4.7a5.632,5.632,0,0,0-5-2.3c-4.1,0-6.3,2.8-6.7,6.4-.3,3.5,1.5,6.4,5.5,6.4a7.444,7.444,0,0,0,5.5-2.4l-.4,4.8A11.327,11.327,0,0,1,41,32.1c-6.6-.2-9.5-5.1-9.1-10.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M51,11.8h3.8l-1.4,16H61c0,.2-.3,3.7-.3,3.7H49.2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M71,19.1a6.889,6.889,0,0,1,.3-.8h.1c0,.2.1.5.1.8.2.9,1.7,5.9,1.7,5.9H68.3s2.6-5.8,2.7-5.9m1-8.2h-.3L61.2,31.4h4.1l1.5-3.1h7.4l.9,3.1h4.1Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "c",
    transform: "translate(180.173 30.513)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Portal"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxedAlumniPortalLogoV3);
export default __webpack_public_path__ + "static/media/Boxed-Alumni-Portal-Logo-v3.712e398a4d8e74761d6ef79b3251ccf6.svg";
export { ForwardRef as ReactComponent };